export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceName: "アイラ地域サポート",
      serviceContentsSettings: [
        {
          serviceContentsId: 2,
          serviceContentsUuid: "servicecontents002",
          contentsName: "地域サポート",
          serviceType: "hoam",
          deviceTypeUuid: "device001",
          deviceType: "JS01K",
          screenOrientationKbn: 1,
          contentsSettings: {

          },
          contentsScreenSettings: [
            {
              screenConfigMstId: 21,
              contentsScreenUuid: "contentsscreen021",
              contentsScreenId: 21,
              screenName: "トップ画面",
              screenConfigName: "地域サポート向けトップ画面",
              isHomeScreen: 1,
              isReleased: 1,
              screenSettings: {
                
              }
            },
            {
              screenConfigMstId: 22,
              contentsScreenUuid: "contentsscreen022",
              contentsScreenId: 22,
              screenName: "お知らせ画面",
              screenConfigName: "地域サポート向けトップ画面",
              isHomeScreen: 1,
              isReleased: 1,
              screenSettings: {
                
              }
            }
          ]
        },
        {
          serviceContentsId: 1,
          serviceContentsUuid: "servicecontents001",
          contentsName: "アコミュニティサポート",
          serviceType: "hoambox",
          deviceTypeUuid: "device002",
          deviceType: "JS01H",
          screenOrientationKbn: 1,
          contentsSettings: {

          },
          contentsScreenSettings: [
            {
              screenConfigMstId: 1,
              contentsScreenUuid: "contentsscreen001",
              contentsScreenId: 1,
              screenName: "トップ画面",
              screenConfigName: "コミュニティサポート向けトップ画面",
              isHomeScreen: 1,
              isReleased: 1,
              screenSettings: {
                
              }
            },
            {
              screenConfigMstId: 2,
              contentsScreenUuid: "contentsscreen002",
              contentsScreenId: 2,
              screenName: "お知らせ画面",
              screenConfigName: "コミュニティサポート向けお知らせ画面",
              isHomeScreen: 1,
              isReleased: 1,
              screenSettings: {
                
              }
            }
          ]
        },
      ]
    }
  }
}